import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslationService } from '../../translations/services/translation.service';

@Component({
  selector: 'app-dropdown-multiple-search',
  templateUrl: './dropdown-multiple-search.component.html',
  styleUrls: ['./dropdown-multiple-search.component.scss'],
  providers: [TranslationService],
  standalone: false
})
export class DropdownMultipleSearchComponent implements OnChanges {
  @Input() id: string;
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() options: string[];
  @Input() editMode: boolean;
  @Input() label: string;
  @Input() multipleOption: boolean = true;
  @Input() placeholder: string = '';

  processedOptions: string[];

  public translationService = inject(TranslationService);

  ngOnChanges(changes: SimpleChanges): void {
    if (('editMode' in changes || 'options' in changes) && this.editMode && Array.isArray(this.options)) {
      const values = this.formGroup.get(this.controlName).value;
      const formControlValue = values === null ? [] : Array.isArray(values) && values.includes('All') ? this.options : values;
      this.formGroup.get(this.controlName).setValue(formControlValue);
      this.processedOptions = this.arrangeDropdownOptions(this.options, formControlValue);
    }
  }

  onDropdownOpenedChange() {
    let values = this.formGroup.get(this.controlName).value;
    let formControlValue = values === null ? [] : Array.isArray(values) && values.includes('All') ? this.options : values;
    this.formGroup.get(this.controlName).setValue(formControlValue);
    this.processedOptions = this.arrangeDropdownOptions(this.options, formControlValue);
  }

  arrangeDropdownOptions(allOptions: string[], selectedOptions: string[]) {
    const sortedList = allOptions.slice();
    sortedList.sort((a, b) => {
      const isInSelectedOptionsA = selectedOptions.includes(a);
      const isInSelectedOptionsB = selectedOptions.includes(b);

      if (isInSelectedOptionsA && !isInSelectedOptionsB) {
        return -1;
      } else if (!isInSelectedOptionsA && isInSelectedOptionsB) {
        return 1;
      }

      if (isInSelectedOptionsA && isInSelectedOptionsB) {
        return a.localeCompare(b);
      }
      return 0;
    });

    return sortedList;
  }
}
